import { TermForm } from './term-form';
import { SellerLocation } from './loi-form';
import { effectiveLeaseAssumption } from './effective-lease-assumption';
import { TermsFormLinkedField } from './terms-form-linked-field';
import { EmployeeConsiderationPayer } from './employee-consideration-payer.enum';

function hasValue(val: string | number | null | undefined): boolean {
    if (val == null) return false;
    if (typeof val === 'number') return val !== 0;
    if (typeof val === 'string') return val.trim() !== '';
    return true;
}

export function hasValueForLinkedField(
    termForm: TermForm | null | undefined,
    field: TermsFormLinkedField,
    sellerLocations: SellerLocation[] = []
): boolean {
    if (!termForm) return false;
    const summary = termForm.purchasePriceSummary;
    const cash = summary?.cashAtCloser;
    switch (field) {
        case TermsFormLinkedField.CashAtCloser:
            return hasValue(cash?.cashAtClose);
        case TermsFormLinkedField.NetCashAtCloser:
            return hasValue(cash?.netCashAtCloser);
        case TermsFormLinkedField.DeferredFixedPayments: {
            const rows = summary?.deferredFixedPayments?.rows ?? [];
            return rows.length > 0 && rows.some((r) => hasValue(r.amount));
        }
        case TermsFormLinkedField.DeferredVariablePayments: {
            const rows = summary?.deferredVariablePayments?.rows ?? [];
            return rows.length > 0 && rows.some((r) => hasValue(r.valueAtClosing));
        }
        case TermsFormLinkedField.JvEquity:
            return hasValue(summary?.jvEquity?.row?.valueAtClosing);
        case TermsFormLinkedField.CorporateEquity: {
            const rows = summary?.corporateEquity?.rows ?? [];
            return rows.some((r) => hasValue(r.valueAtClosing));
        }
        case TermsFormLinkedField.Other:
            return hasValue(summary?.other);
        case TermsFormLinkedField.PracticePropertyPurchased:
            return hasValue(termForm.propertyPurchased?.practicePropertyPurchased);
        case TermsFormLinkedField.PracticeRealPropertyIncluded:
            return termForm.locations?.some(l =>
                effectiveLeaseAssumption(l.leaseAssumption, sellerLocations.find(s => s.locationId === l.locationId)) === 'purchase'
            ) ?? false;
        case TermsFormLinkedField.OwnerEmploymentExpected:
            // An explicit "No" row is a stored answer, not an expected employment (missing flag = legacy "Yes" row).
            return (termForm.sellingOwnerEmploymentAgreementRows ?? []).some((r) => r.isEmployedPostClose !== false);
        case TermsFormLinkedField.LeaseAssumedOrNew:
            return termForm.locations?.some(l => l.leaseAssumption === 'new') ?? false;
        case TermsFormLinkedField.EmployeeConsiderationPresent:
            return termForm.employeeConsiderationPayer != null && termForm.employeeConsiderationPayer !== EmployeeConsiderationPayer.No;
        default:
            return false;
    }
}
